import { useHospitalDetailContext } from '../hospital-detail-context'

import { HospitalCreditCardSection } from '@/features/hospital/components/hospital-credit-card-section'
import { HospitalLoanSection } from '@/features/hospital/components/HospitalLoanSection'
import { CountryCodes } from '@/utils/language'

export const HospitalDetailPaymentOptions = () => {
  const { hospital } = useHospitalDetailContext()

  // 일본이 아닌 경우 렌더링하지 않음
  if (hospital.country !== CountryCodes.JP) {
    return null
  }

  return (
    <div>
      <HospitalCreditCardSection hospital={hospital} />
      <HospitalLoanSection hospital={hospital} />
    </div>
  )
}
